// Action names
import { CALL_API } from 'store/api';
import { API_SERVICE } from 'utils/apiService';
export const LIVE_AIRMEET_TOGGLE_HOST_VISIBILITY =
    'LIVE_AIRMEET_TOGGLE_HOST_VISIBILITY';
export const LIVE_AIRMEET_UPDATE_STREAMS_LAYOUT =
    'LIVE_AIRMEET_UPDATE_STREAMS_LAYOUT';

export const LIVE_AIRMEET_UPDATE_REACTIONS_LIST =
    'LIVE_AIRMEET_UPDATE_REACTIONS_LIST';
export const LIVE_AIRMEET_SET_DATA = 'LIVE_AIRMEET_SET_DATA';
export const SET_INVITED_SPEAKERS_DATA = 'SET_INVITED_SPEAKERS_DATA';
export const LIVE_AIRMEET_SET_LAYOUT = 'LIVE_AIRMEET_SET_LAYOUT';
export const SET_LITE_MODE_ENABLED = 'SET_LITE_MODE_ENABLED';
export const SET_ACTIVE_WATCH_MODE = 'SET_ACTIVE_WATCH_MODE';
export const ADD_STAGE_INVITATION = 'ADD_STAGE_INVITATION';
export const CHANGE_PENDING_INVITATION_FLAG = 'CHANGE_PENDING_INVITATION_FLAG';
export const SET_STREAM_LIMIT_MODAL_VISIBILITY =
    'SET_STREAM_LIMIT_MODAL_VISIBILITY';
export const SET_STAGE_MEMBER_LIMIT_REACHED = 'SET_STAGE_MEMBER_LIMIT_REACHED';
export const SET_TABLE_CODE = 'SET_TABLE_CODE';
export const CHANGE_RESOLUTION_MENU_STATUS = 'CHANGE_RESOLUTION_MENU_STATUS';
export const UPDATE_STAGE_ONLINE_MEMBERS = 'UPDATE_STAGE_ONLINE_MEMBERS';
export const UPDATE_USER_PRESENCE_MEMBERS = 'UPDATE_USER_PRESENCE_MEMBERS';
export const SET_AIRMEET_VISIT_ID = 'SET_AIRMEET_VISIT_ID';
export const SET_DEFAULT_BACKDROP = 'SET_DEFAULT_BACKDROP';
export const SET_LOCAL_STREAM_IN_MIRROR = 'SET_LOCAL_STREAM_IN_MIRROR';
export const UPDATE_CHECK_DM_NOTIFICATION_THRESHOLD =
    'UPDATE_CHECK_DM_NOTIFICATION_THRESHOLD';
export const SET_LAST_DM_NOTIFICATION_TIME = 'SET_LAST_DM_NOTIFICATION_TIME';
export const SET_SOCIAL_STREAMING = 'SET_SOCIAL_STREAMING';
export const SET_FILTER_INFO = 'SET_FILTER_INFO';
export const SET_FILTER_ENABLED = 'SET_FILTER_ENABLED';
export const SET_PERMISSION_WORKFLOW_VERSION =
    'SET_PERMISSION_WORKFLOW_VERSION';
export const SET_BREAKOUT_ACTIVE = 'SET_BREAKOUT_ACTIVE';
export const BREAKOUT_ROOM_JOIN_STATUS = 'BREAKOUT_ROOM_JOIN_STATUS';
export const SET_PERMISSION_SETUP_COMPLETE = 'SET_PERMISSION_SETUP_COMPLETE';
export const SET_IN_AIRMEET_PERMISSION_SETUP_COMPLETE =
    'SET_IN_AIRMEET_PERMISSION_SETUP_COMPLETE';
export const AUTHENTICATE_UNAUTHENTICATE_INVITED_SPEAKER =
    'AUTHENTICATE_UNAUTHENTICATE_INVITED_SPEAKER';

export const sessionBaseProps = {
    reactions: {},
    raiseHands: {},
};

// Action dispatchers
// export const toggleHostVisibility = (visible) => ({
//     type: LIVE_AIRMEET_TOGGLE_HOST_VISIBILITY,
//     payload: visible,
// });

// export const setLiveEventLayout = (layout) => ({
//     type: LIVE_AIRMEET_UPDATE_STREAMS_LAYOUT,
//     payload: layout,
// });

export const setPermissionSetupComplete = (payload) => ({
    type: SET_PERMISSION_SETUP_COMPLETE,
    payload: payload,
});

export const setInAirmeetPermissionSetupComplete = (payload) => ({
    type: SET_IN_AIRMEET_PERMISSION_SETUP_COMPLETE,
    payload: payload,
});
export const updateReactionsList = (sessionId, reactions) => ({
    type: LIVE_AIRMEET_UPDATE_REACTIONS_LIST,
    payload: {
        sessionId,
        reactions,
    },
});
export const updateUserPresenceMembers = (presenceIn, members) => ({
    type: UPDATE_USER_PRESENCE_MEMBERS,
    payload: {
        presenceIn,
        members,
    },
});

export const updateStageMembers = (stageId, members) => ({
    type: UPDATE_STAGE_ONLINE_MEMBERS,
    payload: {
        stageId,
        members,
    },
});

export const setLiteModeEnabled = (isEnabled) => ({
    type: SET_LITE_MODE_ENABLED,
    payload: isEnabled,
});

export const setActiveWatchMode = (mode) => ({
    type: SET_ACTIVE_WATCH_MODE,
    payload: mode,
});

export const setResolutionMenuOpen = (status) => ({
    type: CHANGE_RESOLUTION_MENU_STATUS,
    payload: status,
});

export const setLiveAirmeetData = (data) => ({
    type: LIVE_AIRMEET_SET_DATA,
    payload: data,
});

export const addStageInvitation = (data) => ({
    type: ADD_STAGE_INVITATION,
    payload: data,
});

export const changePendingInvitationFlag = (data) => ({
    type: CHANGE_PENDING_INVITATION_FLAG,
    payload: data,
});

export const setStageMemberLimitReached = (data) => ({
    type: SET_STAGE_MEMBER_LIMIT_REACHED,
    payload: data,
});

export const setIsStreamLimitModalVisible = (data) => ({
    type: SET_STREAM_LIMIT_MODAL_VISIBILITY,
    payload: data,
});

export const setTableCode = (code) => ({
    type: SET_TABLE_CODE,
    payload: code,
});

export const setAirmeetVisitId = (visitId) => ({
    type: SET_AIRMEET_VISIT_ID,
    payload: visitId,
});

export const setDefaultBackdrop = (status) => ({
    type: SET_DEFAULT_BACKDROP,
    payload: status,
});

export const toggleLocalStreamMirror = () => ({
    type: SET_LOCAL_STREAM_IN_MIRROR,
});

export const updateCheckDmNotificationThreshold = (value) => ({
    type: UPDATE_CHECK_DM_NOTIFICATION_THRESHOLD,
    payload: value,
});

export const setLastDmNotificationTime = (value) => ({
    type: SET_LAST_DM_NOTIFICATION_TIME,
    payload: value,
});

export const setSocialStreaming = (value) => ({
    type: SET_SOCIAL_STREAMING,
    payload: value,
});

export const setFilterInfo = (value) => ({
    type: SET_FILTER_INFO,
    payload: value,
});

export const setFilterEnabled = (value) => ({
    type: SET_FILTER_ENABLED,
    payload: value,
});

export const setPermissionWorkflowVersion = (value) => ({
    type: SET_PERMISSION_WORKFLOW_VERSION,
    payload: value,
});

export const setBreakoutActive = (isActive) => ({
    type: SET_BREAKOUT_ACTIVE,
    payload: isActive,
});

export const setBreakoutRoomJoinStatus = (value) => ({
    type: BREAKOUT_ROOM_JOIN_STATUS,
    payload: value,
});

export function authenticateUnauthenticateInvitedSpeaker({
    airmeetId,
    data,
    type,
}) {
    return {
        [CALL_API]: {
            types: [AUTHENTICATE_UNAUTHENTICATE_INVITED_SPEAKER],
            endpoint: `/airmeet/${airmeetId}/session/speaker/live`,
            body: data,
            type: 'json',
            method: type,
            service: API_SERVICE.ZEUS,
        },
    };
}

export const setInvitedSpeakersData = (value) => ({
    type: SET_INVITED_SPEAKERS_DATA,
    payload: value,
});
